// 센서 데이터 polling 설정 (Map.tsx와 SensorStatusFloating.tsx에서 공통 사용)
export const SENSOR_DATA_POLLING_INTERVAL = 10000; // 10초
